import { CardStep } from './CardStep';

export type { TypeCardStepProps } from './types';
export default CardStep;
